/**
 * Always-on offer pill. Appears after a short delay and re-opens the pop-up section.
 * Can be closed with the x button; the dismissal is remembered in a cookie.
 */
const OFFER_COOKIE = 'pop-up-offer-dismissed';

document.querySelectorAll('[data-popup-offer]').forEach((offer) => {
  const designMode = window.Shopify && Shopify.designMode;
  const isDismissed = () => document.cookie.split('; ').some((c) => c.startsWith(`${OFFER_COOKIE}=`));

  const reveal = () => {
    offer.hidden = false;
    // Next frame so the transition runs from the hidden state.
    requestAnimationFrame(() => requestAnimationFrame(() => offer.classList.add('is-visible')));
  };

  offer.querySelector('.popup-offer__open').addEventListener('click', async (evt) => {
    await customElements.whenDefined('pop-up');
    const popup = document.getElementById(offer.dataset.target);
    if (popup) popup.open(evt.currentTarget);
  });

  offer.querySelector('[data-popup-offer-close]').addEventListener('click', () => {
    offer.classList.remove('is-visible');
    offer.addEventListener('transitionend', () => { offer.hidden = true; }, { once: true });
    setTimeout(() => { offer.hidden = true; }, 600);

    if (!designMode) {
      const days = parseInt(offer.dataset.dismissDays, 10) || 400;
      const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
      document.cookie = `${OFFER_COOKIE}=true; expires=${expires}; path=/; SameSite=None; Secure`;
    }
  });

  if (designMode) {
    reveal();
  } else if (!isDismissed()) {
    setTimeout(reveal, Number(offer.dataset.delay) * 1000);
  }
});
